import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './ContextualAlertButton.types.js';
import styles from './ContextualAlertButton.module.scss.js';

var ContextualAlertButton = /** @class */ (function (_super) {
    __extends(ContextualAlertButton, _super);
    function ContextualAlertButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextualAlertButton.prototype.render = function () {
        var _a = this.props, className = _a.className, variant = _a.variant, disabled = _a.disabled, children = _a.children, onClick = _a.onClick, buttonProps = __rest(_a, ["className", "variant", "disabled", "children", "onClick"]);
        return (React__default.createElement("button", __assign({ onClick: onClick, disabled: disabled, className: clsx(styles.ContextualAlertButton, styles['ContextualAlertButton___' + variant], className) }, buttonProps), children));
    };
    ContextualAlertButton.displayName = 'ContextualAlertButton';
    ContextualAlertButton.propTypes = propTypes;
    ContextualAlertButton.defaultProps = __assign({}, defaultProps);
    return ContextualAlertButton;
}(React__default.Component));

export { ContextualAlertButton, ContextualAlertButton as default };
